export const rules = {
    service_id: [
        { required: false, message: 'Пожалуйста, выберите Услуги', trigger: 'blur' },
    ],
    form_template_id: [
        { required: true, message: 'Пожалуйста, выберите Шаблоны', trigger: 'blur' },
    ],
};
